
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Button,
} from 'element-ui';
import { ISetting } from '@/types/set.d';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Button,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加配置',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: ISetting;

  mounted() {
    if (this.title.includes('编辑')) this.form = this.oldForm;
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }
}
